import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, useTheme } from '@mui/material';
import Lottie from 'lottie-react';
import runningHorse from '../runningHorse.json'; // coloque o arquivo na pasta do projeto

const HorseLoader = ({ text }: { text?: string }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  // O Lottie é preto-e-branco; no tema escuro o cavalo preto somia. Invertendo,
  // o preto vira branco e fica visível sobre o fundo escuro.
  const isDark = theme.palette.mode === 'dark';
  const label = text ?? t('common.loading');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        py: 3,
      }}
    >
      <Lottie
  animationData={runningHorse}
  loop
  style={{
    width: 200,
    height: 200,
    transform: 'scaleX(-1)', // Inverte o lado
    filter: isDark ? 'invert(1)' : undefined, // cavalo branco no tema escuro
  }}
/>

      {label && (
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            color: 'text.secondary',
            fontWeight: 500,
            animation: 'fadeInOut 1.8s ease-in-out infinite',
            '@keyframes fadeInOut': {
              '0%': { opacity: 0.5 },
              '50%': { opacity: 1 },
              '100%': { opacity: 0.5 },
            },
          }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default HorseLoader;
